// components/pages/MenuPage.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 2rem;
  text-align: center;
`;

const MenuGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
`;

const MenuItem = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  padding: 1.5rem;
  text-align: center;
`;

const MenuTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
`;

const MenuDescription = styled.p`
  margin-bottom: 1.5rem;
  color: #555;
`;

const Button = styled.button`
  background-color: #007bff;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  
  &:hover {
    background-color: #0069d9;
  }
`;

const BackLink = styled(Link)`
  display: block;
  margin-top: 1rem;
  text-align: center;
  color: #555;
  
  &:hover {
    text-decoration: underline;
  }
`;

const MenuPage: React.FC = () => {
  return (
    <Container>
      <Title>Select Map Type</Title>
      
      <MenuGrid>
        <MenuItem>
          <MenuTitle>World Map</MenuTitle>
          <MenuDescription>
            Explore global geographic data visualizations
          </MenuDescription>
          <Button>Select</Button>
        </MenuItem>
        
        <MenuItem>
          <MenuTitle>Countries</MenuTitle>
          <MenuDescription>
            Country-specific data visualization options
          </MenuDescription>
          <Button>Select</Button>
        </MenuItem>
        
        <MenuItem>
          <MenuTitle>Regions</MenuTitle>
          <MenuDescription>
            Regional mapping and data visualization tools
          </MenuDescription>
          <Button>Select</Button>
        </MenuItem>
        
        <MenuItem>
          <MenuTitle>Custom Map</MenuTitle>
          <MenuDescription>
            Create your own customized map visualizations
          </MenuDescription>
          <Button>Select</Button>
        </MenuItem>
      </MenuGrid>
      
      <BackLink to="/">← Back to Home</BackLink>
    </Container>
  );
};

export default MenuPage;